import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200" data-id="element-23">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="md:flex md:items-center md:justify-between" data-id="element-25">
          <div className="flex justify-center md:justify-start" data-id="element-26">
            <Link to="/" className="flex items-center" data-id="element-27">
              <div className="bg-white p-1 rounded-lg shadow-md" data-id="element-28">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9YiZ8fYR9MF9BFf8vhx3gU/Kastom_Printing_Logo.png" alt="Kastom Printing Logo" className="h-14 w-auto" data-id="element-29" />
              </div>
              <span className="ml-2 text-xl font-bold text-gray-900 sr-only" data-id="element-30">
                Kastom Printing
              </span>
            </Link>
          </div>
          <div className="mt-8 md:mt-0" data-id="element-31">
            <p className="text-center text-base text-gray-500" data-id="element-32">
              &copy; {new Date().getFullYear()} Kastom Printing. All rights
              reserved.
            </p>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between" data-id="element-33">
          <div className="flex justify-center space-x-6 md:justify-start" data-id="element-34">
            <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-35">
              <span className="sr-only" data-id="element-36">Facebook</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-37">
                <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-38" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-39">
              <span className="sr-only" data-id="element-40">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-41">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-42" />
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-red-500" data-id="element-43">
              <span className="sr-only" data-id="element-44">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-45">
                <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-46" />
              </svg>
            </a>
          </div>
          <nav className="mt-4 flex flex-wrap justify-center space-x-6 md:mt-0 md:justify-end" data-id="element-47">
            <Link to="/about" className="text-sm text-gray-500 hover:text-red-500" data-id="element-48">
              About
            </Link>
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-red-500" data-id="element-49">
              Privacy
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-red-500" data-id="element-50">
              Terms
            </Link>
            <Link to="/contact" className="text-sm text-gray-500 hover:text-red-500" data-id="element-51">
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </footer>;
}